import api from '@utils/api';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import aftercareSlice from './aftercare.slice';
import { AftercareActionTypes } from './common.types';
function* handleFetchAftercare() {
    const aftercare = yield call(api.aftercareRequest);
    yield put(aftercareSlice.actions.updateAftercareRequest(aftercare));
}
function* handleUpdateAftercare(action) {
    const aftercareRequest = action.payload;
    yield put(aftercareSlice.actions.updateAftercareRequest(aftercareRequest));
}
function* watchFetchRequest() {
    yield takeEvery(AftercareActionTypes.FETCH_AFTERCARE, handleFetchAftercare);
    yield takeEvery(AftercareActionTypes.UPDATE_AFTERCARE, handleUpdateAftercare);
}
export default function* aftercareSaga() {
    yield all([fork(watchFetchRequest)]);
}
